import React, { useState, useEffect } from 'react';
import { FaTrash } from 'react-icons/fa';
import { useGlobalContext } from '../GlobalContext';

const DaftarSimpSaham = () => {
  const { periode, api } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    tanggal: new Date().toISOString().split('T')[0],
  });
  const [simpData, setSimpData] = useState([]);
  const [message, setMessage] = useState('');

  const parseNumber = (value) => {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return value;

    const normalized = String(value).trim().replace(/\s/g, '');
    if (!normalized) return 0;

    const cleaned = normalized.includes(',')
      ? normalized.replace(/\./g, '').replace(',', '.')
      : normalized.replace(/,/g, '');

    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 0,
    }).format(parseNumber(value));
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;

    return date.toLocaleDateString('id-ID', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  const fetchSimpData = async () => {
    setLoading(true);
    setMessage('');

    try {
      const endpoint = `/api/laporan/saham/${formData.tanggal}/${formData.tanggal}`;
      const response = await api.get(endpoint);
      const dataArray = Array.isArray(response.data)
        ? response.data
        : (Array.isArray(response.data?.data) ? response.data.data : []);

      setSimpData(dataArray);
    } catch (error) {
      console.error('Error fetching simpanan saham data:', error);
      setMessage('Gagal mengambil data simpanan saham. Silakan coba lagi.');
      setSimpData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDeleteSimpSaham = async (notransaksi) => {
    if (!notransaksi) {
      return alert('Nomor transaksi tidak tersedia.');
    }

    if (!window.confirm('Yakin ingin menghapus transaksi simpanan saham ini?')) {
      return;
    }

    try {
      await api.delete(`/api/transaksi/simpananusp/${notransaksi}`);
      alert('Transaksi berhasil dihapus.');
      fetchSimpData();
    } catch (error) {
      console.error('Error deleting simpanan saham:', error);
      alert('Gagal menghapus transaksi. Silakan coba lagi.');
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchSimpData();
  };

  useEffect(() => {
    fetchSimpData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.tanggal]);

  const totalPokok = simpData.reduce((sum, row) => sum + parseNumber(row.spokok), 0);
  const totalWajib = simpData.reduce((sum, row) => sum + parseNumber(row.swajib), 0);

  return (
    <div className="container-fluid mt-4">
      <div className="card" style={{ borderTop: '3px solid #17a2b8' }}>
        <div className="card-header" style={{ backgroundColor: '#17a2b8', color: 'white', fontWeight: 'bold' }}>
          <h5 className="card-title mb-0">Daftar Simp. Saham</h5>
        </div>

        <div className="card-body">
          <form onSubmit={handleSearch}>
            <div className="row mb-3">
              <div className="col-md-3">
                <label htmlFor="tanggal" className="form-label" style={{ fontWeight: 'bold', fontSize: '14px' }}>Tanggal</label>
                <input
                  type="date"
                  className="form-control"
                  id="tanggal"
                  name="tanggal"
                  value={formData.tanggal}
                  onChange={handleInputChange}
                  style={{ fontSize: '14px' }}
                />
              </div>
              <div className="col-md-2" style={{ paddingTop: '31px' }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                  style={{ fontSize: '14px' }}
                >
                  {loading ? 'Mencari...' : 'Cari'}
                </button>
              </div>
            </div>
          </form>

          {message && (
            <div className="alert alert-info alert-dismissible fade show" role="alert" style={{ marginTop: '15px', fontSize: '14px' }}>
              {message}
            </div>
          )}

          <div className="table-responsive mt-4">
            <table className="table table-bordered" style={{ fontSize: '14px', marginBottom: '0' }}>
              <thead>
                <tr style={{ backgroundColor: '#17a2b8', color: 'white', fontWeight: 'bold' }}>
                  <th style={{ width: '5%', padding: '10px', textAlign: 'center', borderColor: '#17a2b8' }}>No.</th>
                  <th style={{ width: '12%', padding: '10px', borderColor: '#17a2b8' }}>Tanggal</th>
                  <th style={{ width: '13%', padding: '10px', borderColor: '#17a2b8' }}>No. Transaksi</th>
                  <th style={{ width: '10%', padding: '10px', borderColor: '#17a2b8' }}>No. Anggota</th>
                  <th style={{ width: '18%', padding: '10px', borderColor: '#17a2b8' }}>Nama</th>
                  <th style={{ width: '12%', padding: '10px', textAlign: 'right', borderColor: '#17a2b8' }}>Simp. Pokok</th>
                  <th style={{ width: '12%', padding: '10px', textAlign: 'right', borderColor: '#17a2b8' }}>Simp. Wajib</th>
                  <th style={{ width: '8%', padding: '10px', textAlign: 'center', borderColor: '#17a2b8' }}>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(simpData) && simpData.length > 0 ? (
                  simpData.map((row, index) => (
                    <tr key={`${row.notransaksi || 'row'}-${index}`} style={{ borderColor: '#ddd' }}>
                      <td style={{ padding: '8px', textAlign: 'center', borderColor: '#ddd' }}>{index + 1}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{formatDate(row.tanggal)}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{row.notransaksi || '-'}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{row.noanggota || '-'}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{row.nama || '-'}</td>
                      <td style={{ padding: '8px', textAlign: 'right', borderColor: '#ddd' }}>
                        {formatNumber(row.spokok || 0)}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'right', borderColor: '#ddd' }}>
                        {formatNumber(row.swajib || 0)}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'center', borderColor: '#ddd' }}>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          title="Hapus"
                          onClick={() => handleDeleteSimpSaham(row.notransaksi)}
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center" style={{ padding: '20px', color: '#999', borderColor: '#ddd' }}>
                      {loading ? 'Memproses data...' : 'Tidak ada data. Silakan gunakan filter untuk mencari data.'}
                    </td>
                  </tr>
                )}
                {Array.isArray(simpData) && simpData.length > 0 && (
                  <tr style={{ borderTop: '2px solid #17a2b8' }}>
                    <td colSpan="5" style={{ padding: '10px', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8', textAlign: 'center' }}>
                      Total:
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8' }}>
                      {formatNumber(totalPokok)}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8' }}>
                      {formatNumber(totalWajib)}
                    </td>
                    <td style={{ padding: '10px', borderColor: '#ddd' }} />
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DaftarSimpSaham;
